var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-table-cell-event-value data-table-cell-group"},[_c('forms-input',{attrs:{"icon-post":"copy","icon-post-interactive":"","read-only":"","size":_vm.$pepper.Size.S,"value":_vm.content},on:{"iconClick":_vm.onCopy}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }